export default __webpack_public_path__ + "static/media/8.ce1c6830.png";